module.exports = __webpack_public_path__ + "static/img/a3.ca41913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a3.png
// module id = TKM8
// module chunks = 0